/* Auto-submit localization forms when a select changes. */
(() => {
  'use strict';
  if (window.__purrLocalizationBound) return;
  window.__purrLocalizationBound = true;
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-localization-select]');
    if (!select) return;
    const form = select.closest('form');
    if (form) form.submit();
  });
})();
